import { ILoadingOverlayParams } from "ag-grid-community";
import { Spinner } from "@livingmap/hippo";

const LoadingOverlay: React.FC<ILoadingOverlayParams> = () => {
  return <Spinner dataQA="loading-spinner" size={48} />;
};

export default LoadingOverlay;
